import { postAjax } from '../helpers/ajax'
import DomManipulate from './DomManipulate';

export default class Tooltip {
    constructor(tooltipContainer, ...option) {
        this.attrTooltip = '[data-tooltip]';
        this.tooltipContainer = tooltipContainer;
        this.ajaxRequestUrl = option[0]
        this.delay = 100;
        this.setTimeOutConst;
        this.dom = new DomManipulate();
    }
    init() {
        if (!this.attrTooltip) {
            return
        }

        this.dom.onReady(() => {
            this.onMouseEnterAll(this.attrTooltip)
        })
    }

    reInit() {
        if (!this.attrTooltip) {
            return
        }
        this.onMouseEnterAll(this.attrTooltip)
    }

    toShow(mouseEnterElement) {
        let elementToHide = document.querySelector('.shown')
        if (elementToHide) {
            elementToHide.classList.remove('shown')
        }
        let elementToShow = mouseEnterElement.firstElementChild;
        this.onMouseOver(elementToShow)
        elementToShow.classList.add('shown')
    }

    toHide(elementTohide) {
        elementTohide.classList.remove('shown')
    }

    onMouseOver(onMouseOutElement) {
        document.body.addEventListener('mouseover', (e) => {
            if (!onMouseOutElement.contains(e.target)) {
              this.toHide(onMouseOutElement)
            }
        })
    }

    onMouseEnterAll(tooltipSelector) {
        this.elements = document.querySelectorAll(tooltipSelector)
        for (let i = 0; i < this.elements.length; i++) {
            if (!this.elements) {
                return
            }
            this.elements[i].addEventListener("mouseenter", () => {
                if (this.ajaxRequestUrl) {
                    this.setTimeOutConst = setTimeout(() => {
                        postAjax(this.ajaxRequestUrl, 'vehicleid=' + this.elements[i].getAttribute('data-vehicle-id'), (response) => {

                        })
                        this.toShow(this.elements[i])
                    }, this.delay)
                }
                this.elements[i].addEventListener("click", () => {
                  let link = this.elements[i].getAttribute('data-redirect')
                  window.location.href = link
                })
            })
            this.elements[i].addEventListener("mouseout", () => {
                clearTimeout(this.setTimeOutConst)
            })
        }
    }

};
